import {
    GET_STATE_FATIGUE,
    GET_STATE_FATIGUE_ERROR,
    GET_STATE_FATIGUE_SUCCESS,
} from './Truckaproach.actions';

const FatigueState = {
    lista: [],
    loading_state: true,
    error_state: undefined,
};

/**
 * The Fatigue reducer.
 */
const fatigueReducer = (state = FatigueState, { payload, type }) => {
    switch (type) {
        case GET_STATE_FATIGUE: {
            return {
                ...state,
                loading_state: true,
                error_state: undefined,
            };
        }
        case GET_STATE_FATIGUE_ERROR: {
            return {
                ...state,
                loading_state: false,
                error_state: payload.error,
            };
        }
        case GET_STATE_FATIGUE_SUCCESS: {
            return {
                ...state,
                loading_state: false,
                error_state: undefined,
                lista: payload.lista,
            };
        }
        default:
            return state;
    }
};

export default fatigueReducer;